import rank1 from 'assets/icons/xpLevel1.svg';
import rank10 from 'assets/icons/xpLevel10.svg';
import rank2 from 'assets/icons/xpLevel2.svg';
import rank3 from 'assets/icons/xpLevel3.svg';
import rank4 from 'assets/icons/xpLevel4.svg';
import rank5 from 'assets/icons/xpLevel5.svg';
import rank6 from 'assets/icons/xpLevel6.svg';
import rank7 from 'assets/icons/xpLevel7.svg';
import rank8 from 'assets/icons/xpLevel8.svg';
import rank9 from 'assets/icons/xpLevel9.svg';

import xpLevel1 from 'assets/icons/xpLevel1.svg';
import xpLevel10 from 'assets/icons/xpLevel10.svg';
import xpLevel2 from 'assets/icons/xpLevel2.svg';
import xpLevel3 from 'assets/icons/xpLevel3.svg';
import xpLevel4 from 'assets/icons/xpLevel4.svg';
import xpLevel5 from 'assets/icons/xpLevel5.svg';
import xpLevel6 from 'assets/icons/xpLevel6.svg';
import xpLevel7 from 'assets/icons/xpLevel7.svg';
import xpLevel8 from 'assets/icons/xpLevel8.svg';
import xpLevel9 from 'assets/icons/xpLevel9.svg';

export const TRACK_ID_OF_META = '6152da77240d00c672aedc71';
export const RECOMMENDATION_TRACK_ID = '634fc8ba728529fdb380e507';
export const META_S3_URL = 'https://metaassets.s3.us-east-2.amazonaws.com/';
export const INFO = '/info';
export const PRIVACY_POLICY = [
  'עודכן לאחרונה: אפריל 2021',
  'עמותת תפוח (ע״ר) מכבדת את פרטיותם של המשתמשים הנכנסים לאתר www.makesapp.co  ומשתמשים בשירות המוצע במסגרתו (״השירות״). מטרת התנאים המפורטים במסמך זה ואשר מהווים חלק בלתי נפרד מתנאי השימוש שלנו, הנה לפרט, בין היתר, את האופן בו אנו אוספים, משתמשים ומשתפים נתונים אודותיך שמסרת לנו או שנאספו על ידינו בעת השימוש שלך בשירות. השימוש בשירות ייחשב כהסכמה מפורשת ומדעת מצדך לכל התנאים המפורטים במסמך זה. מדיניות פרטיות זו חלה על האתר שלנו אשר מפנה להצהרה זו, אך אינה חלה על אתרים ושירותים של חברות וארגונים מקושרים אלינו הכוללים הצהרת פרטיות משלהם.',
  'אתה מתחייב ומצהיר כי גילך הינו 18 שנים לפחות, או שאתה נרשם לשירות באישורו של אחד מהוריך או האפוטרופוס שאחראי עליך ובהסכמתו למדיניות פרטיות זו במלואה. ',
  'שמירה על פרטיותם של ילדים חשובה לנו במיוחד. אנו לא מאפשרים ביודעין לילדים מתחת לגיל 13 להירשם לשירות. אנו מעודדים הורים ואפוטרופוסים לפקח על השימוש של ילדם באינטרנט. אנו ממליצים להורים להורות לילדיהם לא למסור את שמותיהם האמתיים, כתובותיהם, מספרי הטלפון שלהם או מידע אישי אחר ללא אישור של הורה או אפוטרופוס בעת השימוש באינטרנט. אם נמצא כי מידע אישי של ילד מתחת לגיל 13 נאסף בשירות שלנו ללא הסכמת ההורים, ננקוט בצעדים מתאימים למחיקת מידע זה. אם אתה הורה או אפוטרופוס ומגלה שלילד שלך מתחת לגיל 13 יש ללא הסכמתך חשבון רשום בשירות שלנו, או אם ברצונך כי נסיר את פרטיך או פרטי ילדך ממאגרי המידע שלנו, באפשרותך לפנות אלינו לצורך כך באמצעות דוא״ל: e.plus.dev1@gmail.com או באמצעות פנייה בכתב לכתובת: רחוב טשרניחובסקי 3, רמלה, ישראל.',
];
export const TERMS_AND_CONDITIONS = [
  'כללי',
  'אתר האינטרנט אליו נכנסת (“האתר”) מופעל על-ידי עמותת תפוח – עמותה לקידום עידן המידע בישראל (ע”ר) (“העמותה”). המשתמש באתר (“המשתמש”) מתבקש לקרוא בעיון רב את כל תנאי השימוש המפורטים להלן (“תנאי השימוש”), שכן השימוש והגלישה באתר מותנים בקבלה והסכמה מצדו של המשתמש לכל תנאי השימוש וכן למדיניות הפרטיות של האתר (“מדיניות הפרטיות”), לרבות כפי שישונו ו/או יתעדכנו מעת לעת. ככל שהמשתמש אינו מסכים לתנאי השימוש, כולם או חלקם, הוא אינו רשאי לגלוש באתר ו/או לעשות בו כל שימוש לכל מטרה שהיא. כל משתמש אשר יגלוש או יעשה שימוש באתר ייחשב כמי שהסכים לכל תנאי השימוש ולכל תנאי מדיניות הפרטיות. מובהר בזאת כי מדיניות הפרטיות מהווה חלק בלתי נפרד מתנאי השימוש. תנאי השימוש מתייחסים ומיועדים לגברים ונשים כאחד על פי הקשר הדברים, וזאת בין אם נעשה שימוש בלשון זכר, בלשון נקבה או בלשון רבים. למען הסר ספק, השימוש בלשון זכר, נקבה או רבים הנו לצורך הנוחות בלבד.',
  'האתר מיועד למשתמשים בגילאי 13-18. מודגש, כי השימוש על ידי משתמש שטרם מלאו לו 18 ייעשה אך ורק לאחר שניתן אישור הוריו/אפוטרופוסיו לכך, לרבות קבלה מלאה ובלתי מסויגת מצד הוריו/אפוטרופוסיו של כל האמור בתנאי שימוש אלו, לרבות כפי שיתעדכנו מעת לעת. כמו כן, המשתמש אחראי לקבל אישור מתאים טרם העלאת מידע/תכנים/תמונות לאתר אשר נוגעים לכל אדם מלבד למשתמש עצמו.',
  'העמותה שומרת לעצמה את הזכות לשנות, מעת לעת, את תנאי השימוש, להוסיף עליהם או לגרוע מהם, וזאת ביחס לאתר, כולו או חלקו, למאפיינים שלו (Features) או ליישומים שלו (Applications). הכל, בהתאם לשיקול דעתה הבלעדי והמוחלט של העמותה וללא צורך במסירת הודעה כלשהי למשתמשים. העמותה תהיה רשאית להמחות ו/או להעביר את זכויותיה ביחס לאתר, ובלבד שהגורם אליו תועברנה/תומחינה הזכויות כאמור יפעל בהתאם להוראות תנאי שימוש אלו (אולם זאת מבלי לגרוע מזכותו של אותו גורם לשנות ו/או לעדכן את הוראות תנאי השימוש, ומרגע שעשה כן יוכפף המשתמש לתנאי השימוש העדכניים, כאמור לעיל).',
  'העמותה אף תהיה רשאית, בהתאם לשיקול דעתה הבלעדי והמוחלט, וללא צורך במתן הודעה מראש, לשנות, מעת לעת, את מבנה האתר, התכנים המוצגים בו, השירותים והמוצרים המוצעים בו, וכל היבט אחר הנוגע אליהם, ובכלל זה למחוק או להסיר כל מידע או תכנים שיוצגו באתר. המשתמש מוותר על כל זכות ו/או טענה ביחס לשינויים שיכול ויבוצעו כאמור ו/או לכל נזק ו/או תקלה שעלולים להיגרם בקשר עם כך.',
  'מבלי לגרוע מהאמור לעיל, מובהר כי הזנה או העלאה של נתונים או של תוכן בכל חלק של האתר (לרבות השתתפות ויצירת שיתופים בחלקים המיועדים לכך, עשיית שימוש ביישומים השונים, משלוח תגובות, משלוח קבצים וכיוצא באלו) כפופים לתנאי השימוש הכלליים באתר ו/או לתנאי שימוש ספציפיים נוספים אשר מפורטים באותם חלקים של האתר אשר מאפשרים את הזנת התכנים.',
  'המשתמש אחראי לבדוק ולהכיר את כל תנאי השימוש באתר, לרבות כפי שיתעדכנו מעת לעת.',
  'המשתמש עשוי להידרש לבצע שורה של בחירות ו/או קביעת/שינוי ברירות מחדל שיגדירו את היקף הנתונים אשר ייחשפו ביחס למשתמש ואת היקף המשתמשים אשר יוכלו לחזות בנתונים האמורים. בחלק מהמקרים, תכלולנה ברירות המחדל חשיפה של פרטים מסוימים לסוג מסוים של משתמשים. במקרים אלו, ככל שהמשתמש יבקש למנוע או לשנות את היקף החשיפה של אותם פרטים, יהיה עליו לשנות את ברירות המחדל הרלוונטיות. המשתמש אחראי, בכל פעם בה יזין נתונים באתר ו/או יבחר בביצוע פעולה מסוימת באתר ו/או ישנה ו/או יותיר על כנן ברירות מחדל קיימות באתר אשר נוגעות במישרין או בעקיפין למשתמש, לאופן שימושו באתר, לזהות והיקף הגורמים אשר ייחשפו לנתוני המשתמש ו/או לבחירותיו כאמור לעיל ו/או לאופן הצגתם של הנתונים הנוגעים למשתמש בפני צדדים שלישיים, לוודא היטב כי ביצוע הפעולות האמורות משקף נכונה הן את מהות הנתונים שברצונו לציין ו/או לחשוף והן את היקפם והרכבם של המשתמשים העשויים להיחשף לנתונים האמורים, במישרין או בעקיפין. ',
  'נתונים אשר נוגעים למשתמש ואשר נוצרו ו/או נחשפו ו/או אשר המשתמש שיתף לגביהם ו/או סיפק גישה ביחס אליהם בעת שהמשתמש היה רשום באתר עשויים להוסיף ולהיראות באתר גם לאחר שהמשתמש יחדל לגלוש בו (ואף אם ימחק את חשבון המשתמש שלו באתר). המשתמש יכול לעדכן את נתוני החשבון שלו בכל זמן נתון, אולם נתונים מסוימים אשר נוגעים למשתמש אינם ניתנים למחיקה כלל (למשל, מסרים שנשלחו מן המשתמש למשתמשים אחרים). כאשר המשתמש מקפיא את פעילות חשבון המשתמש שלו, אף משתמש אחר לא יוכל לראות את חשבון המשתמש אולם החשבון לא יימחק, וזאת על מנת שהמשתמש יוכל לשוב ולעשות שימוש בחשבון אם וכאשר ירצה בכך במועד מאוחר יותר. כאשר המשתמש מוחק את חשבון המשתמש שלו, החשבון יימחק לצמיתות והמשתמש לא יוכל לעשות בו כל שימוש נוסף בעתיד, ולכן מומלץ למשתמש לשקול היטב ולהיות משוכנע בדבר רצונו למחוק את חשבון המשתמש שלו בטרם הוא עושה כן. העמותה עשויה לשמור ברשותה פרטים הקשורים למשתמש לאחר מחיקת חשבון המשתמש שלו, וזאת לטובת מניעה של התחזות ו/או שימוש בלתי מורשה בנתונים הקשורים למשתמש על ידי גורמים אחרים. כמו כן, מידע שנמחק על ידי המשתמש עשוי להישמר בקבצי גיבוי של האתר (שכן העמותה מבצעת פעולות גיבוי ביחס לאתר מעת לעת), אולם זאת לפרק זמן אשר בכל מקרה לא יעלה על 180 יום מן המועד בו נמחק אותו מידע על ידי המשתמש. כמו כן, קיימת אפשרות כי משתמשים אחרים יעתיקו ו/או יעשו שימוש בנתונים אשר נוגעים למשתמש כאמור לעיל, וכן ייתכן כי בחירות שביצעו ו/או ברירות מחדל שהגדירו משתמשים אחרים ימנעו, למשל, הופעה של מסרים ששלח להם המשתמש בדף המשתמש שלהם. כניסה לאתרים ו/או ליישומים אחרים (ו/או כניסה באמצעות הנ”ל לאתר) עשויה להגביל ו/או לחשוף את פעולות המשתמש בשל מדיניות שמירת הפרטיות ו/או ברירות המחדל המוגדרות באותם אתרים ו/או יישומים.',
];

export const STOCK_MARKET_DISCORD = 'https://discord.gg/n4JPASnZ2f';
export const UNITY_DISCORD = 'https://discord.gg/z8VhMKFkNQ';
export const VIDEO_DISCORD = 'https://discord.gg/dGR4WpBw59';
export const MATH_DISCORD = 'https://discord.gg/fnnaqxpnVB';
export const DEFAULT_DISCORD_URL =
  'https://discord.com/channels/791641232639262720/794144779066671104';
export const DISCORD_HELP_ICON = 'discord_help_icon';
export const ONBOARDING_MAKE_ID = '61cc2088f9eee42c49796739';

export const LEVEL_MAKE_DIC = { easy: 'קל', hard: 'קשה', medium: 'בינוני' };
export const MAKES_APP = 'https://www.makesapp.co/';
export const MAKES_DISCORD = 'https://discord.com/invite/nPrNrXuNBv';
export const GOOGLE_SEARCH = 'https://www.google.com/search?q=';

export const INFO_FIRST_TITLE = 'מה צריך לדעת לפני המייק הזה?';
export const INFO_SECOND_TITLE = 'אחרי המייק הזה תדעו';
export const TOOLS = ['image', 'paint', 'text', 'textBackground'];
export const COLOR_SEQUENCE = [
  'var(--color-white)',
  'var(----color-mid-grey)',
  'var(--color-black)',
  'var(--color-red)',
  'var(--color-orange)',
  'var(--color-yellow)',
  'var(--color-green)',
  'var(--color-dark-green)',
  'var(--color-light-blue)',
  'var(--color-blue)',
  'var(--color-pink)',
  'var(--color-purple)',
];

export const STAT_NAMES = [
  'התקדמות',
  'מספר MAKES',
  'לייקים שהתקבלו',
  'התקבלו נקודות',
  'התקבל XP',
  'התקבלו כוכבים',
];

export const HEBREW_MONTH = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר ',
  'נובמבר',
  'דצמבר',
];

export const ranksIcons = [
  rank1,
  rank2,
  rank3,
  rank4,
  rank5,
  rank6,
  rank7,
  rank8,
  rank9,
  rank10,
];

export const XP_ICONS = [
  xpLevel1,
  xpLevel2,
  xpLevel3,
  xpLevel4,
  xpLevel5,
  xpLevel6,
  xpLevel7,
  xpLevel8,
  xpLevel9,
  xpLevel10,
];
export const DESKTOP_CARDS_NUMBER = 3;

export const RECOMMENDATION_ID = '634fc8ba728529fdb380e507';
